import React from "react";
import { View, Text, StyleSheet, Platform, Dimensions } from "react-native";
import CrossPlatformDropdown from "../../../components/CrossPlatformDropdown";
import { TOUCHPOINT_OPTIONS } from "../../../constants/touchpoints";
import { useTheme } from "../../../theme";

// Define the DropdownItem interface to match what's in CrossPlatformDropdown
interface DropdownItem {
  id: string | number;
  displayText: string;
  [key: string]: any;
}

interface NHOFiltersProps {
  dropdownOptions: {
    employees: Array<{ id: string; displayText: string }>;
    observationTypes: Array<{ id: string; displayText: string }>;
  };
  filters: {
    employee: string;
    observationType: string;
  };
  setFilters: React.Dispatch<
    React.SetStateAction<{
      employee: string;
      observationType: string;
    }>
  >;
  showValidation: boolean;
}
const isIPad = Platform.OS === "ios" && Dimensions.get("window").width >= 768;
const NHOFilters: React.FC<NHOFiltersProps> = ({
  dropdownOptions,
  filters,
  setFilters,
  showValidation,
}) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const labelColor = isDark ? '#FFFFFF' : '#212529';
  return (
    <View style={styles.filtersContainer}>
      <View style={styles.filterItem}>
        <Text style={[styles.filterLabel, { color: labelColor }]}>Employee*</Text>
        <CrossPlatformDropdown
          childList={dropdownOptions.employees}
          selectedValue={
            filters.employee
              ? {
                  id: filters.employee,
                  displayText:
                    dropdownOptions.employees.find(
                      (e) => e.id === filters.employee
                    )?.displayText || "",
                }
              : null
          }
          setSelectedValue={(value: DropdownItem | DropdownItem[] | null) => {
            // Handle single selection
            if (value && !Array.isArray(value)) {
              setFilters((prev) => ({
                ...prev,
                employee: value.id.toString(),
              }));
            }
            // Handle no selection
            else if (value === null) {
              setFilters((prev) => ({
                ...prev,
                employee: "",
              }));
            }
          }}
          placeholder="Select Employee"
          helperText={
            showValidation && !filters.employee ? "Employee is required" : ""
          }
          feedbackType={showValidation && !filters.employee ? "error" : "info"}
          testID="nho-employee-dropdown"
        />
      </View>
      <View style={styles.filterItem}>
        <Text style={[styles.filterLabel, { color: labelColor }]}>Touch Type*</Text>
        <CrossPlatformDropdown
          childList={TOUCHPOINT_OPTIONS}
          disableSorting={true}
          selectedValue={
            filters.observationType
              ? {
                  id: filters.observationType,
                  displayText:
                    TOUCHPOINT_OPTIONS.find(option => option.id === filters.observationType)?.displayText || "",
                }
              : null
          }
          setSelectedValue={(value: DropdownItem | DropdownItem[] | null) => {
            // Handle single selection
            if (value && !Array.isArray(value)) {
              setFilters((prev) => ({
                ...prev,
                observationType: value.id.toString(),
              }));
            }
            // Handle no selection
            else if (value === null) {
              setFilters((prev) => ({
                ...prev,
                observationType: "",
              }));
            }
          }}
          placeholder="Select Touch Type"
          helperText={
            showValidation && !filters.observationType
              ? "Touch Type is required"
              : ""
          }
          feedbackType={
            showValidation && !filters.observationType ? "error" : "info"
          }
          testID="nho-observation-type-dropdown"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    gap: 16,
    marginBottom: 8,
    flexDirection: Platform.OS === "web" || isIPad ? "row" : "column",
    //flexDirection: Platform.OS === "web" ? "row" : "column",
    width: "100%",
    justifyContent: "space-between",
  },
  filterItem: {
    marginBottom: 12,
    width: Platform.OS === "web" || isIPad ? "48%" : "100%",
  },
  filterLabel: {
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 4,
    color: "#212529",
  },
});

export default NHOFilters;
